import React from 'react';
import styled from 'styled-components';

import useCurrentCourse from '@src/hooks/useCurrentCourse';
import CourseMain from '@src/components/course/basicInfo/courseCard/courseMain';

import VideoPlayer from './videoPlayer';
import Detail from './detail';

const ASPECT_RATIO = 16 / 9;

const MediaWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media ${props => props.theme.device.lgDesktop} {
		width: calc(100% - 412px);
		margin-right: 10px
	}

	@media ${props => props.theme.device.desktop} {
		width: calc(100% - 350px);
		margin-right: 10px
	}
`;

const CoverImage = styled.div`
	background: #FFFFFF;
	height: calc(100vw / ${ASPECT_RATIO});
	width: 100vw;

	.cover-image__image {
		background-image: url(${props => props.imageSrc});
		background-size: cover;
		width: 100%;
		height: 100%;
		background-repeat: no-repeat;
		background-position: center;
	}

	@media
		${props => props.theme.device.lgDesktop},
		${props => props.theme.device.desktop}
		{
			height: 410px;
			width: 100%;
		}
`;

const DetailWrapper = styled.div`
	background: #ffffff;
	padding: 12px 20px 0 20px;
	overflow: hidden;
	flex: 1 1 auto;

	@media
		${props => props.theme.device.lgDesktop},
		${props => props.theme.device.desktop}
		{
			padding: 12px 20px;
			box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
		}
`;

const CourseMainWrapper = styled(CourseMain)`
	@media
		${props => props.theme.device.lgDesktop},
		${props => props.theme.device.desktop}
		{
			display: none;
		}
`;

const Media = (): JSX.Element => {
	const {
		currentCourse: {
			title, teacher, video_link, cover_link,
			embedded_video_url,
			using_embedded_video,
		},
	} = useCurrentCourse();
	const videoLink = using_embedded_video ? embedded_video_url : video_link?.link;

	return (
		<MediaWrapper>
			{
				videoLink ? (
					<VideoPlayer link={videoLink} aspectRatio={ASPECT_RATIO} />
				) : (
					<CoverImage imageSrc={cover_link?.link}>
						<div className="cover-image__image" />
					</CoverImage>
				)
			}
			<DetailWrapper>
				<CourseMainWrapper
					title={title}
					name={teacher?.name || ''}
					nickname={teacher?.nickname || ''}
					avatar={teacher?.cover_link?.link}
				/>
				<Detail />
			</DetailWrapper>
		</MediaWrapper>
	);
};

export default Media;
